import { render, staticRenderFns } from "./update-candidate-form.html?vue&type=template&id=771482b7&scoped=true&external"
import script from "./update-candidate-form.js?vue&type=script&lang=js&external"
export * from "./update-candidate-form.js?vue&type=script&lang=js&external"
import style0 from "./update-candidate-form.scss?vue&type=style&index=0&id=771482b7&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771482b7",
  null
  
)

export default component.exports